<template>
    <div class="layout" :class="`layout--${this.$route.name}`">
        <block-header />
        <div class="layout__main">
            <router-view />
        </div>
    </div>
</template>

<script>
    import BlockHeader from './header.vue'

    export default {
        components: {
            BlockHeader
        }
    }
</script>

<style lang="stylus" scoped>
    .layout {
        max-width 94rem
        margin 0 auto
        height 100%
        +layout-sm() {
            display flex
            flex-direction column
            height auto
            width 100%
            max-width 100%
        }
        &__main {
            background-color #362AEE
            color #BEE6FE
            font-size 1.8rem
            height 58rem
            overflow hidden
            +layout-sm() {
                height 100%
                flex 1 1
                overflow inherit
            }
        }
        &--hello {
            >>> .game__header {
                +layout-sm() {
                    display none
                }
            }
        }
    }
</style>

